










import { Component } from 'nuxt-property-decorator'
// @ts-ignore
import { NewCouponEntrance } from '@klook/promo-entrance'
import TourBusinessBase from '~/components/tour/tour-base/business-base'
import '@klook/promo-entrance/dist/promo-entrance.esm.css'

@Component({
  components: {
    NewCouponEntrance
  }
})
export default class TourPromoSection extends TourBusinessBase {
  static displayName = 'PlatformPromoCodes'

  get calcArr() {
    return this.businessData?.items || []
  }

  get couponData() {
    const { items = [], more_deep_link = '', more_title = '', title = '' } = this.businessData || {}
    return {
      couponList: items,
      title,
      moreTitle: more_title,
      moreDeepLink: more_deep_link
    }
  }
}
